import React from "react";
import { Grid } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";
import GeocoderSearch from "../../../../Common/GeocoderSearchBox";
import CustomTextField from "../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomTextField";
import { ToggleRenderer } from "../../../../../dataGrid/cellRenderer";
import constant from "../Constant";
import {
  ONLY_NUMBER_REGEX,
  ALPHA_NUMERIC_REGEX,
  ONLY_ALPHA_REGEX,
} from "../../../../Dispatch/RouteExecution/constRegex";

const Fields = ({
  classes,
  terminalInfo,
  errorInfo,
  inputValue,
  theme,
  terminalList,
  toggleAutoZooms,
  handleChange,
  propsTerminalInfo,
  getLocationDetails,
  getAddress,
  errorMessage,
}) => {
  const getList = (fieldName) => {
    //create a option for given field Name
    return [
      ...new Set(terminalList.map((terminal) => terminal[fieldName])),
    ].map((option) => {
      return {
        label: option,
        value: option,
      };
    });
  };

  return (
    <div className={`${classes.dataContainer} ${classes.formContainer}`}>
      <Grid container spacing={24} className={classes.gridContainer}>
        <div className={classes.divStyle}>
          <div
            className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${classes.toggleAnimationButtonMenu} `}
          >
            <div className={classes.toggleText}>Terminal Status</div>
            <ToggleRenderer
              value={terminalInfo?.isEnabled}
              onChange={() => toggleAutoZooms(terminalInfo.isEnabled)}
            />
          </div>
          <Grid container xs={12}>
            <Grid item xs={4} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="TerminalCode"
                  label="Code"
                  handleChange={handleChange("terminalCode")}
                  error={errorInfo?.terminalCode}
                  value={terminalInfo.terminalCode}
                  disabled={Boolean(propsTerminalInfo)}
                  inputProps={{
                    maxLength: constant.TERMINAL_CODE_LENGTH,
                    pattern: ALPHA_NUMERIC_REGEX,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={8} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="Name"
                  label="Name"
                  handleChange={handleChange("terminalName")}
                  error={errorInfo?.terminalName}
                  value={terminalInfo.terminalName}
                  inputProps={{
                    maxLength: constant.MAX_LENGTH_50,
                    pattern: ONLY_ALPHA_REGEX,
                  }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "region",
                    label: "Region",
                    variant: "outlined",
                    helperText: errorInfo.region,
                  }}
                  value={terminalInfo.region}
                  error={Boolean(errorInfo.region)}
                  onChange={handleChange("region")}
                  data={getList("regionName")}
                  canAcceptNewValue
                  newValueParams={constant.REGION_VALUE_PARAMS}
                  createLabel={`Add ${terminalInfo?.region ?? ""}`}
                />
              </div>
            </Grid>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "division",
                    label: "Division",
                    variant: "outlined",
                    helperText: errorInfo.division,
                  }}
                  value={terminalInfo.division}
                  error={Boolean(errorInfo.division)}
                  onChange={handleChange("division")}
                  data={getList("divisionName")}
                  isDisabled={Boolean(propsTerminalInfo)}
                  canAcceptNewValue
                  newValueParams={constant.DIVISION_VALUE_PARAMS}
                  createLabel={`Add ${terminalInfo?.division ?? ""}`}
                />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12} className={classes.formClass}>
            <div className={classes.flexRow}>
              <div
                className={`${classes.editorContainer} ${
                  Boolean(errorInfo.address) && "error"
                }`}
              >
                <GeocoderSearch
                  getLocationDetails={getLocationDetails}
                  inputValue={inputValue ? inputValue : getAddress()}
                  originalLat={propsTerminalInfo?.latitude}
                  originalLng={propsTerminalInfo?.longitude}
                  geocoderTheme={theme.themeName}
                  error={Boolean(errorInfo.address)}
                ></GeocoderSearch>
                {Boolean(errorInfo.address) && (
                  <div
                    className={`MuiFormHelperText-root MuiFormHelperText-error ${classes.errorMessageVisible}`}
                  >
                    {errorInfo.address}
                  </div>
                )}
              </div>
            </div>
          </Grid>
          <Grid container xs={12}>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="city"
                  label="City"
                  handleChange={handleChange("city")}
                  error={errorInfo?.city}
                  value={terminalInfo.city}
                  inputProps={{
                    maxLength: constant.MAX_LENGTH_50,
                    pattern: ONLY_ALPHA_REGEX,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="State"
                  label="State"
                  handleChange={handleChange("state")}
                  error={errorInfo?.state}
                  value={terminalInfo.state}
                  inputProps={{
                    maxLength: constant.MAX_LENGTH_50,
                    pattern: ONLY_ALPHA_REGEX,
                  }}
                />
              </div>
            </Grid>
          </Grid>
          <Grid container xs={12}>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="country"
                  label="Country"
                  handleChange={handleChange("country")}
                  error={errorInfo?.country}
                  value={terminalInfo.country}
                  inputProps={{
                    maxLength: constant.MAX_LENGTH_50,
                    pattern: ONLY_ALPHA_REGEX,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="zip"
                  label="Zip Code"
                  handleChange={handleChange("zip")}
                  error={errorInfo?.zip}
                  value={terminalInfo.zip}
                  inputProps={{
                    maxLength: constant.MAX_ZIP_LENGTH,
                    max: constant.MAX_ZIP,
                    pattern: ONLY_NUMBER_REGEX,
                  }}
                />
              </div>
            </Grid>
          </Grid>

          <Grid container xs={12}>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="Latitude"
                  label="Latitude"
                  handleChange={handleChange("latitude")}
                  error={errorInfo?.latitude}
                  value={terminalInfo.latitude}
                />
              </div>
            </Grid>
            <Grid item xs={6} className={classes.formClass}>
              <div className={classes.flexRow}>
                <CustomTextField
                  id="Longitude"
                  label="Longitude"
                  handleChange={handleChange("longitude")}
                  error={errorInfo?.longitude}
                  value={terminalInfo.longitude}
                />
              </div>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={8} className={classes.formClass}>
              <div className={classes.flexRow}>
                <Select
                  textFieldProps={{
                    id: "utcToLocalOffset",
                    label: "UTC to Local Offset",
                    variant: "outlined",
                    helperText: errorInfo.utcToLocalOffset,
                  }}
                  value={terminalInfo.utcToLocalOffset}
                  error={Boolean(errorInfo.utcToLocalOffset)}
                  onChange={handleChange("utcToLocalOffset")}
                  data={constant.VALID_OFFSET}
                />
              </div>
            </Grid>
          </Grid>
          <div className={classes.noteText}>
            Note - You can update Geofence by using lasso tool to mark area on
            map
          </div>
          {errorMessage && (
            <div className={classes.errorMessage}>{errorMessage}</div>
          )}
        </div>
      </Grid>
    </div>
  );
};

export default Fields;
